interface Props {
  size?: number;
  variant?: 'ring' | 'fill';
  color?: string;
  accent?: string;
}

export function CadranGlyph({
  size = 22,
  variant = 'ring',
  color = 'currentColor',
  accent = 'var(--terracotta)',
}: Props) {
  if (variant === 'fill') {
    return (
      <svg width={size} height={size} viewBox="0 0 100 100" aria-hidden="true">
        <circle cx="50" cy="50" r="48" fill={accent} />
        <circle cx="50" cy="10" r="7" fill="var(--paper)" />
      </svg>
    );
  }
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" aria-hidden="true">
      <circle cx="50" cy="50" r="46" fill="none" stroke={color} strokeWidth="6" />
      <circle cx="50" cy="9" r="11" fill={accent} />
    </svg>
  );
}
